import { ReactElement } from 'react';
import { VStack } from '@chakra-ui/react';
import { SectionTitle, SectionVariant } from './SectionTitle';

type SectionProps = {
  variant: SectionVariant;
  children: ReactElement[] | undefined;
  hasButton?: boolean;
  onClickButton?: () => void;
  buttonContent?: ReactElement | string;
};

export const Section = ({
  children,
  variant,
  hasButton = false,
  onClickButton,
  buttonContent,
}: SectionProps): ReactElement => {
  const lowTitleSpacing =
    variant === SectionVariant.ARTICLE || variant === SectionVariant.MEDICATION;
  return (
    <VStack
      alignItems="left"
      bg="background.primary"
      width="100%"
      p={{ base: '12px 16px', md: '20px' }}
      borderRadius={{ md: '2xl' }}
      gap={lowTitleSpacing ? { md: '10px' } : { md: '25px' }}
    >
      <SectionTitle
        variant={variant}
        hasButton={hasButton}
        onClickButton={onClickButton}
        buttonContent={buttonContent}
      />
      <VStack mt="3" align="left" gap={lowTitleSpacing ? '0px' : '20px'}>
        {children}
      </VStack>
    </VStack>
  );
};
